import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, styled } from '@mui/material';

import { BaseText, LabelText, SmallText } from './shared/index.js';

const InfoContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: 16,
}));

const InfoRow = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  gap: 8,
});

const EmailContainer = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginLeft: 32,
});

const EmailSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

type InfoBlockProps = {
  readonly email: string;
};

const InfoBlock = ({ email }: InfoBlockProps) => (
  <InfoContainer>
    <InfoRow>
      <InfoOutlinedIcon sx={{ color: 'text.secondary' }} />
      <BaseText color="text.primary" sx={{ fontSize: 14 }} variant="body1">
        We sent an email with a confirmation code to this email
      </BaseText>
    </InfoRow>
    <EmailContainer>
      <EmailSection>
        <LabelText variant="body1">Email</LabelText>
        <SmallText color="text.primary" variant="subtitle2">
          {email}
        </SmallText>
      </EmailSection>
    </EmailContainer>
  </InfoContainer>
);

export default InfoBlock;
